import { Button, Inline, ListItem } from 'chaoskit/src/components'
import PropTypes from 'prop-types'
import { connectMenu } from 'react-instantsearch-dom'

const CategoryMenu = ({ items, refine }) => (
  <Inline css={{ justifyContent: 'center' }}>
    {items.map((item) => (
      <ListItem key={item.label}>
        <Button
          type={item.isRefined ? 'secondary' : 'default'}
          onClick={() => refine(item.value)}
          size="small"
        >
          {item.label}
        </Button>
      </ListItem>
    ))}
  </Inline>
)

CategoryMenu.propTypes = {
  items: PropTypes.array,
  refine: PropTypes.func,
}

export const CustomCategoryMenu = connectMenu(CategoryMenu)
